import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment';
import { getPostCats } from '../../../../core/actions/postGet';
import { Table, Icon, Button, Tag, Row } from 'antd';
import { Link  } from 'react-router-dom'

export class PostCatManagement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      postcats: [],
      columns: [
        // {
        //   title: 'USER ID',
        //   dataIndex: 'id',
        //   key: 'id'
        // },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name'
        }, 
        {
          title: 'Slug',
          dataIndex: 'slug',
          key: 'slug',
          render: (text, record) => (
            <span>
              <Tag color="blue" className="tag">{record.slug}</Tag>
            </span>
          )
        }, 
        {
          title: 'AUTHOR',
          dataIndex: 'author',
          key: 'author'
        },
        {
          title: 'DATE CREATED',
          dataIndex: 'created',
          key: 'created',
          render: (text, record) => (
            <span>
              {moment(record.created).format("MMMM Do YYYY")}
            </span>
          )
        },
        {
          title: 'ACTION',
          key: 'action',
          render: (text, record) => (
            <span>
              <Button type="primary" className="edit-btn" size="small"><Link to={`/editpostcat/${record.slug}`}> Edit <Icon type="edit" /></Link></Button>
              {/* <Button type="danger" size="small"> Delete <Icon type="edit" /></Button> */}
            </span>
          )
        }
      ]
    }

    // this.gotoUser = this.gotoUser.bind(this)
    this.restructurePostcats = this.restructurePostcats.bind(this)
  }

  componentDidMount() {
    // console.log(this.state)
    const { postcats } = this.state;
    if (!postcats.length) {
      this.props.getPostCats();
      // console.warn(postcats)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { postcats } = nextProps;
    console.log(postcats)
    if (postcats.length > 0) {
      // this.setState({ users })
      this.restructurePostcats(postcats)
    }
  }

  // gotoUser(id) {
  //   this.props.history.push(`/settings/manageuser/${id}`);
  //   console.log('going...')
  // }

  restructurePostcats(postcats) {
    let newPostcats = []
    postcats.forEach(element => {
      newPostcats.push(Object.assign(element, {key: element.id}))
    });
    this.setState({
      postcats: newPostcats
    })
  }

  render() {
    const { postcats, columns } = this.state
    return (
      <div className="postcat-mgt">
        <Row>
          <Table dataSource={postcats} columns={columns} />
        </Row>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  postcats: state.allPosts.postcats
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getPostCats
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostCatManagement)
